import React, { useContext, useEffect, useState } from 'react';
import ButtonwithEnter from './ButtonwithEnter';
import { context } from '../App';
import { ReactComponent as PlayButton } from '../assets/play-button.svg';
import { useSearchParams } from 'react-router-dom';

export default function Intro() {
    const { windowWidth, slideCount, referred, referredImg, payload, setSlideCount, isPlayClicked, setIsPlayClicked } = useContext(context);

    const [isPropertyOwner, setIsPropertyOwner] = useState(false);
    const [searchParams] = useSearchParams()
    const staging = searchParams.get('staging');
    const stepIndex = searchParams.get('stepIndex');

    function getInvitationFormats(url) {
        try {
            const parsedUrl = new URL(url);
            let invitation;

            if (parsedUrl.searchParams.has('invitation')) {
                invitation = parsedUrl.searchParams.get('invitation');
            } else {
                const pathSegments = parsedUrl.pathname.split('/');
                invitation = pathSegments[pathSegments.length - 1];
            }

            const dashed = invitation.replace(/-/g, '_');
            const plain = invitation.replace(/-/g, '');
            const original = invitation

            return { dashed, plain, original };
        } catch (error) {
            console.error('Invalid URL:', error);
            return { dashed: '', plain: '', original : '' };
        }
    }

    const invitationName = getInvitationFormats(window.location.href)
    console.log(invitationName);


    useEffect(() => {
        const hostname = window.location.hostname;
        if (window.location.href.includes("propertyowner.proinsight")) {
            setIsPropertyOwner(true);
            setSlideCount(11)
        }
    }, []);

    return (
        <>
            {
                (windowWidth > 1024 || slideCount > 0) && !window.location.href.includes("financing.proinsight") && !window.location.href.includes("apply.proinsight")
                &&
                <div className="left-container">
                    <img style={{ display: slideCount === 0 ? "block" : "none" }} src={(referred && referredImg) ? referredImg : "https://storage.googleapis.com/msgsndr/sIF5ZS1VxhUZsYbvq7gL/media/6655d126ef816ee29da4a24c.jpeg"} alt="left-img" />
                </div>
            }

            {(!window.location.href.includes("financing.proinsight") && !window.location.href.includes("apply.proinsight") && !stepIndex != 2) && <div className="right-container">
                <div style={{ display: slideCount === 0 ? "block" : "none" }} className="slide slide0">
                    <div>
                        {!window.location.href.includes("propertyowner.proinsight") && <div className='iframe-container' style={{ display: (windowWidth > 1024) ? "block" : "none" }}>
                            {/* {
                                referred
                                ?
                                    <iframe src="https://player.vimeo.com/video/1016359640?h=4a43469fc9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="ProInsight 3-Minute Intro">
                                    </iframe>
                                :
                                    <iframe src="https://player.vimeo.com/video/1016359640?h=4a43469fc9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="ProInsight 3-Minute Intro">
                                    </iframe>
                            } */}
                            {/* <iframe src="https://player.vimeo.com/video/1016359640?h=4a43469fc9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="ProInsight 3-Minute Intro">
                            </iframe> */}
                            <iframe src="https://player.vimeo.com/video/1016359640?h=4a43469fc9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="ProInsight 3-Minute Intro">
                            </iframe>
                        </div>}

                        {/* {!window.location.href.includes("propertyowner.proinsight") && <h3 style={windowWidth > 1024 ? { fontSize: '1.4rem', marginTop: 0 } : { order: 1 }}>
                            ProInsight™ is the real estate platform that enables professional introductions
                        </h3>} */}

                        {
                            (windowWidth <= 1024 && slideCount === 0 && !isPlayClicked)
                            &&
                            <div className='sm-img' style={{ marginTop: window.location.href.includes("propertyowner.proinsight") ? "3rem" : "" }} >
                                <img src={(referred && referredImg) ? referredImg : "https://storage.googleapis.com/msgsndr/sIF5ZS1VxhUZsYbvq7gL/media/6655d126ef816ee29da4a24c.jpeg"} alt="left-img" />
                                {!window.location.href.includes("propertyowner.proinsight") && <PlayButton onClick={() => setIsPlayClicked(true)} className='play-button' />}
                            </div>
                        }

                        <h4 style={{ order: 3, fontSize: "14px", fontFamily: "sans-serif" }}>
                            {!window.location.href.includes("propertyowner.proinsight") && payload.introduced_by_name.introduced_by_name && <div style={{ fontSize: "14px", paddingTop: "1rem" }} >
                                <span style={{ display: "block", fontSize: "18px", color: "#d8d3d3" }} >Hello, It's me, {payload.introduced_by_name.introduced_by_name} — your trusted advisor.</span>
                                <span style={{ display: "block", fontSize: "18px", marginTop: "2rem", color: "#d8d3d3" }} >I’ve always connected my favorite property owners with top local professionals — and now, the Homeowner Concierge™ makes it easier and more convenient than ever.</span>
                                <span style={{ display: "block", fontSize: "18px", marginTop: "2rem", color: "#d8d3d3" }} >Whether you’re a professional or a property owner, I hope you’ll join me.</span>
                            </div>
                            }

                            {!window.location.href.includes("propertyowner.proinsight") && !payload.introduced_by_name.introduced_by_name && <div style={{ fontSize: "14px", paddingTop: "1rem" }} >
                                <span style={{ display: "block", fontSize: "18px", color: "#d8d3d3" }} >We are inviting you to a curated community of vetted professionals, trusted experts ready to support every aspect of your property ownership journey.</span>
                            </div>
                            }

                            {/* {window.location.href.includes("propertyowner.proinsight") &&
                                <div style={{ color: "#d8d3d3"}} >As your trusted advisor, I have a question for you about your real estate goals. Click the button below to access it.</div>
                            } */}

                            {/* {
                                !window.location.href.includes("propertyowner.proinsight") ? (<div style={{ fontSize: "18px" }} >{
                                    payload.introduced_by_name.introduced_by_name ? <span> {"Hello, It's me, "}</span> + payload.introduced_by_name.introduced_by_name + ", your trusted advisor." + " You already know how much I value great people. In this short video, I’ll show you how ProInsight™ supports you—whether you’re a property owner who deserves the best professionals, or a trusted expert I believe belongs in this community." : "We are inviting you to a curated community of vetted professionals, trusted experts ready to support every aspect of your property ownership journey."}
                                </div>) :
                                    ""
                            } */}
                        </h4>

                        <div className="intro-button-container" style={{ order: 4 }}>
                            {
                                isPropertyOwner
                                    ?
                                    <ButtonwithEnter type="secondary" indexId="0" width="100%" text="Homeowner" onClickFn={() => setSlideCount(11)} showSpan={false} />
                                    :
                                    <div>
                                        <ButtonwithEnter width="100%" indexId="0" text="I am a Professional" onClickFn={() => {
                                            setSlideCount(2)
                                            // window.open(`https://proinsight.info/homeowner-conceirge-business-model?invitation=${invitationName?.plain}`, "_self");
                                        }} showSpan={false} />
                                        <ButtonwithEnter type="secondary" indexId="0" width="100%" text="Homeowner" onClickFn={() => setSlideCount(11)} showSpan={false} />
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>}

            {window.location.href.includes("apply.proinsight") && 
            <iframe src={`https://proinsight.info/homeowner-conceirge-business-model?invitation=${invitationName?.original}`}
                title="" style={{width:"100%", height:"100vh", border:"none" }} frameborder="0"
                loading="lazy" allowfullscreen aria-label="">
            </iframe>}
        </>
    )
}